import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer section gray-bg">
        <div className="container">
          <div className="row">
            {/* Logo & Info Section */}
            <div className="col-lg-4 mr-auto col-sm-6">
              <div className="widget mb-5 mb-lg-0">
                <div className="logo mb-4">
                  <img src="images/logo.png" alt="" className="img-fluid" />
                </div>
                <p>Varenya Matrimonial is a dedicated platform for the Brahmin community, offering personalized and secure matchmaking for meaningful lifelong connections.</p>
                <ul className="list-inline footer-socials mt-4">
                  <li className="list-inline-item">
                    <a href="https://www.facebook.com/share/1AxPMeVvqu/" target='_blank' rel="noopener noreferrer"><i className="icofont-facebook"></i></a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://www.instagram.com/varenya_matrimonial?utm_source=qr&igsh=ZnQzdTQwcWxrbWFp" target='_blank' rel="noopener noreferrer"><i className="icofont-instagram"></i></a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://www.youtube.com/" target='_blank' rel="noopener noreferrer"><i className="icofont-youtube"></i></a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Quick Links Section */}
            <div className="col-lg-2 col-md-6 col-sm-6 col-6">
              <div className="widget mb-5 mb-lg-0">
                <h4 className="text-capitalize mb-3">Quick Links</h4>
                <div className="divider mb-4"></div>

                <ul className="list-unstyled footer-menu lh-35">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/pricing">Pricing</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                </ul>
              </div>
            </div>

            {/* Support Section */}
            <div className="col-lg-2 col-md-6 col-sm-6 col-6">
              <div className="widget mb-5 mb-lg-0">
                <h4 className="text-capitalize mb-3">Support</h4>
                <div className="divider mb-4"></div>

                <ul className="list-unstyled footer-menu lh-35">
                  <li><Link to="/terms">Terms & Conditions</Link></li>
                  <li><Link to="/privacy">Privacy Policy</Link></li>
                  <li><Link to="/refund">Refund Policy</Link></li>
                  <li><Link to="/faq">FAQ</Link></li>
                </ul>
              </div>
            </div>

            {/* Get in touch Section */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="widget widget-contact mb-5 mb-lg-0">
                <h4 className="text-capitalize mb-3">Get in Touch</h4>
                <div className="divider mb-4"></div>

                <div className="footer-contact-block mb-4">
                  <div className="icon d-flex align-items-center">
                    <i className="icofont-email mr-3"></i>
                    <span className="h6 mb-0">Email Support Available</span>
                  </div>
                  <h4 className="mt-2"><a href="mailto:support@email.com">varenyamatrimonial@gmail.com</a></h4>
                </div>

                <div className="footer-contact-block">
                  <div className="icon d-flex align-items-center">
                    <i className="icofont-support mr-3"></i>
                    <span className="h6 mb-0">Mon to Sat : 10:00 - 18:00</span>
                  </div>
                  <h4 className="mt-2"><a href="tel:+23-345-67890">+91 63603 34247</a></h4>
                </div>
              </div>
            </div>
          </div>

          {/* Footer Bottom Section */}
          <div className="footer-btm py-4 mt-5">
            <div className="row align-items-center justify-content-between">
              <div className="col-lg-12 text-center">
                <div className="copyright">
                  &copy; 2025 <a href="https://www.varenyastudios.com/" target="_blank" rel="noopener noreferrer" className="text-color">Varenya Studios Pvt. Ltd. </a>
                  <span className="d-block d-sm-inline">
                    Developed by <a href="https://softwarejunction.in/" target="_blank" rel="noopener noreferrer">Software Junction</a>
                  </span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4">
                <a className="backtop js-scroll-trigger" href="#top">
                  <i className="icofont-long-arrow-up"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
